var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
import { Heading } from "backpack-ui/dist/components/text";
import * as React from "react";
import Image from "../../../../shared/components/image";
import Text from "../../../../shared/components/text";
import * as styles from "./styles.css";
var Tour = function (_a) {
    var destinations = _a.destinations, duration = _a.duration, image = _a.image, price = _a.price, title = _a.title, url = _a.url, className = _a.className, rest = __rest(_a, ["destinations", "duration", "image", "price", "title", "url", "className"]);
    return (React.createElement("div", __assign({ className: className }, rest),
        React.createElement(Heading, { size: 6, level: 4, weight: "medium" }, "Related tour"),
        React.createElement("a", { className: styles.tourAnchor, href: url },
            React.createElement(Image, { className: styles.tourImage, width: 630, height: 315, src: image, alt: "" }),
            React.createElement(Heading, { size: 5, level: 3, weight: "medium" }, title),
            React.createElement(Text.Meta, { className: styles.tourMeta },
                duration,
                " \u2022 ",
                destinations),
            React.createElement(Text.AccentRed, { className: styles.tourPrice }, price))));
};
export default Tour;



//////////////////
// WEBPACK FOOTER
// ./app/modules/pois/patterns/tour/index.tsx
// module id = tEfT
// module chunks = 2